<div class="company-search-container">
  <div class="company-search-box">
    <app-icon name="search" width="18" height="18" class="search-icon"></app-icon>
    <input
      type="text"
      [(ngModel)]="searchText"
      (input)="onSearchInput(searchText)"
      (focus)="onFocus()"
      [placeholder]="placeholder"
      [disabled]="disabled"
      class="company-search-input"
    />
    <button
      type="button"
      *ngIf="selectedCompany"
      (click)="clearSelection()"
      class="btn-clear-company"
      title="Clear selection"
      [disabled]="disabled"
    >
      ×
    </button>
  </div>

  <!-- Company Dropdown -->
  <div class="company-dropdown" *ngIf="showDropdown && !disabled">
    <div class="dropdown-loading" *ngIf="isSearching">
      <div class="spinner-small"></div>
      Searching companies...
    </div>

    <div class="dropdown-hint" *ngIf="!isSearching && (!searchText || searchText.length < minSearchLength)">
      Type at least {{ minSearchLength }} characters to search
    </div>

    <div *ngIf="!isSearching && searchText.length >= minSearchLength">
      <div class="company-list" *ngIf="filteredCompanies.length > 0">
        <div
          class="company-item"
          *ngFor="let company of filteredCompanies"
          (click)="selectCompany(company)"
        >
          <div class="company-name">{{ company.name }}</div>
          <div class="company-details" *ngIf="company.code">
            <span class="company-code">{{ company.code }}</span>
          </div>
        </div>
      </div>

      <div class="dropdown-empty" *ngIf="filteredCompanies.length === 0">
        No companies found
      </div>
    </div>
  </div>
</div>
